import * as optionsLoadActions from '../actions/applyDefaultOptionsOnLoadFail';
import getStore from '../store/store';
import { extendObservable } from 'mobx';
import { mutator } from 'satcheljs';
import { OwsOptionsFeatureType } from '../store/schema/OwsOptionsFeatureType';

/**
 * Add only the options features where the values are ok to have
 * when the call to Load option fails
 *
 * We don't want to aggravate users by potentially having it
 * enabled or potentially non-default values after they explicitly disabled it.
 */

const featuresToUseDefault: OwsOptionsFeatureType[] = [OwsOptionsFeatureType.SurfaceActions];

mutator(optionsLoadActions.applyDefaultOptionsOnLoadFail, msg => {
    const defaultOptions = msg.defaultOptions;
    featuresToUseDefault.forEach(featureKey => {
        if (defaultOptions[featureKey]) {
            extendObservable(getStore().options[featureKey], defaultOptions[featureKey]);
        }
    });
});
